import { HTMLAttributes } from 'react';
import { ReactComponent as Close } from '../../assets/svg/CloseRed.svg';
import ImageLoader from './ImageLoader';

interface FormUploaderImageProps extends HTMLAttributes<HTMLDivElement> {
    url?: string,
    title?: string,
    deletable?: boolean | undefined,
    deleteTitle?: string,
    onDelete?: () => void,
    imageClassName?: string,
    children?: React.ReactNode;
    rounded?: boolean,
}

function FormUploaderImage({url, title, deletable, deleteTitle, onDelete, imageClassName, rounded = true, ...props}: FormUploaderImageProps) {
    const cls = `form__uploader-image ${props.className || ''}`;

    return (
        <div style={{ display: 'block' }} {...props} className={cls}>
            <div className="form__uploader-image-inner" title={title}>
                <ImageLoader rounded={rounded} className={imageClassName} url={url} />
            </div>
            {deletable &&
                <div className="form__uploader-image-remove" title={deleteTitle} onClick={onDelete}>
                    <Close />
                </div>}
        </div>
    );
}

export default FormUploaderImage;

